<template>
  <div class="callCount" >
    <el-divider content-position="left">外呼记录</el-divider>
    <el-row class="mb-10" :gutter="10">
      <el-col :span="18">
        <el-select v-model="searchArr.caller_number" filterable remote reserve-keyword placeholder="输入姓名搜素" size="mini" clearable :remote-method="remoteMethod" :loading="loading" @change="handleUserChange">
          <el-option v-for="user in users"
          :key="user.id"
          :label="user.username"
          :value="user.job_number">
          </el-option>
        </el-select>
        <el-date-picker :picker-options="ysyTypeInPickerOptions" v-model="searchArr.start_time" size="mini" type="daterange" range-separator="-" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleStartChange"></el-date-picker>
        <el-popover placement="bottom-start" v-model="visible" width="320">
          <el-form :model="searchArr" ref="searchForm" label-width="80px">
            <el-form-item label="方向" prop="direction">
              <el-select v-model="searchArr.direction" placeholder="请选择呼叫方向" size="mini">
                <el-option label="呼出" value="outgoing"></el-option>
                <el-option label="呼入" value="incoming"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="被叫号码" prop="callee_number">
              <el-input style="width: 173px" v-model="searchArr.callee_number" placeholder="请输入被叫号码" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="结果" prop="result">
              <el-select v-model="searchArr.result" placeholder="请选择呼叫方向" size="mini">
                <el-option label="无应答" value="no-answer"></el-option>
                <el-option label="应答" value="answered"></el-option>
                <el-option label="忙碌" value="congestion"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通话时长" prop="seconds">
              <el-select v-model="searchArr.seconds" placeholder="请选择通话时长" size="mini">
                <el-option label="30秒以上" :value="30"></el-option>
                <el-option label="1分钟以上" :value="60"></el-option>
                <el-option label="3分钟以上" :value="180"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
              <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
      <el-col :span="6" class="text-r">
        <el-button type="primary" size="mini" @click="handleCountOpen">统计</el-button>
        <el-popconfirm title="确认切换吗？" @onConfirm="handleChangeLine">
          <el-button :disabled="line === '1'" slot="reference" type="primary" size="mini">切换</el-button>
        </el-popconfirm>
      </el-col>
    </el-row>
    <el-table :data="pageData" size="mini" border style="width: 100%">
      <el-table-column label='姓名'>
        <template slot-scope="scope">
          {{scope.row.user ? scope.row.user.username : '测试'}}
        </template>
      </el-table-column>
      <el-table-column label='方向' prop='direction'></el-table-column>
      <el-table-column label='被叫号码' prop='callee_number'></el-table-column>
      <el-table-column label='结果' prop='result'></el-table-column>
      <el-table-column label='时长'>
        <template slot-scope="scope">
          <span>{{ scope.row.duration_seconds }} 秒</span>
          <i v-if="scope.row.result === '应答' && scope.row.duration_seconds > 0" style="color: #5cb6ff; font-size: .4rem; cursor: pointer;" class="el-icon-mic" @click="play(scope.row.recording_object_name)"></i>
        </template>
      </el-table-column>
      <el-table-column label='日期' prop='start_time'></el-table-column>
    </el-table>
    <el-pagination
      background
      class="mt-10 text-r"
      layout="total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-dialog title="播放" :visible.sync="dialogPlayVisible" :before-close="dialogPlayVisibleBeforeClose">
      <el-row class="playCon">
        <el-card class="card" :body-style="{ padding: '10px' }">
          <div id="waveform" ref="waveform"></div>
        </el-card>
        <div style="padding: 10px" id="wave-timeline" ref="wave-timeline"></div>
      </el-row>
      <div class="text-c">
        <el-button type="primary" @click="playMusic" size="mini">
          <i :class="[isPlay ? 'el-icon-video-pause' : 'el-icon-video-play']"></i>
          {{isPlay ? '暂停' : '播放'}}
        </el-button>
      </div>
    </el-dialog>
    <el-drawer title="外呼统计" :visible.sync="drawer" size="60%" :before-close="handleDrawerBeforeClose">
      <div class="m-tabs-content">
        <el-row class="mb-10">
          <el-col :span="24" class="text-r">
            <el-date-picker  v-model="count_time" size="mini" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="handleCountChange"></el-date-picker>
          </el-col>
        </el-row>
        <el-table :data="countData" size="mini" border style="width: 100%">
          <el-table-column label='姓名' prop='name'></el-table-column>
          <el-table-column label='总数' prop='count'></el-table-column>
          <el-table-column label='应答' prop='answered'></el-table-column>
          <el-table-column label='无应答' prop='no_answer'></el-table-column>
          <el-table-column label='接通率' prop='connect_rate'></el-table-column>
          <el-table-column label='有效时长' prop='efficient'></el-table-column>
          <el-table-column label='平均时长' prop='average'></el-table-column>
          <el-table-column label='有效沟通' prop='communication'></el-table-column>
        </el-table>
        <el-row>
          <el-col :span="3">
            <div class="m-cell">
              总计：
            </div>
          </el-col>
          <el-col :span="3">
            <div class="m-cell-td">
              {{ callCount }}
            </div>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js'
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.js'
import {fscDate} from '../../../static/mixins/fastChooseDate'
export default {
  name: 'CallCount',
  mixins: [fscDate],
  data () {
    return {

      line: null,
      searchArr: {
        caller_number: '',
        start_time: '',
        direction: '',
        result: '',
        seconds: '',
        callee_number: ''
      },
      users: [],
      pageData: [],
      pageOption: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      wavesurfer: null,
      dialogPlayVisible: false,
      isPlay: false,
      loading: false,
      visible: false,
      drawer: false,
      countData: [],
      count_time: '',
      callCount: 0
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getRecords () {
      this.$axios.get('/api/admin/call_clients?page=' + this.pageOption.currentPage + this.searchStr)
        .then((res) => {
          const { data } = res
          if (data.code === 200) {
            this.pageData = data.data.records.data
            this.pageOption.total = data.data.records.total
            this.line = data.data.line
          }
        })
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getRecords()
    },
    play (path) {
      if (!path) {
        this.$message.error('录音为空')
        return
      }

      this.$axios.post('/api/admin/call/getObject', {filePath: path})
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.dialogPlayVisible = true
            this.waveSurferInit(data.data)
          }
        })
    },
    waveSurferInit (src) {
      this.$nextTick(() => {
        this.wavesurfer = WaveSurfer.create({
          container: this.$refs.waveform,
          barWidth: 1,
          cursorColor: 'black',
          progressColor: 'blue',
          backend: 'MediaElement',
          audioRate: '1',
          plugins: [
            Timeline.create({
              container: '#wave-timeline'
            })
          ]
        })
        this.wavesurfer.load(src)
        let that = this
        this.wavesurfer.on('finish', function () {
          that.isPlay = false
        })
      })
    },
    playMusic () {
      this.wavesurfer.playPause.bind(this.wavesurfer)()
      this.isPlay = this.wavesurfer.isPlaying()
    },
    dialogPlayVisibleBeforeClose (done) {
      this.isPlay = false
      this.wavesurfer.destroy()
      done()
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchUsers(query)
        }, 200)
      } else {
        this.users = []
      }
    },
    searchUsers (query) {
      this.$axios.get('/api/admin/searchUsers/' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.users = data.data
          }
        })
    },
    handleUserChange (val) {
      this.pageOption.currentPage = 1
      this.getRecords()
    },
    handleStartChange (val) {
      this.pageOption.currentPage = 1
      this.getRecords()
    },
    resetForm (formName) {
      this.visible = false
      this.$refs[formName].resetFields()
      this.pageOption.currentPage = 1
      this.getRecords()
    },
    submitForm (formName) {
      this.visible = false
      this.getRecords()
    },
    handleCountOpen () {
      this.$axios.get('/api/admin/call_client/count?start_time=' + this.count_time)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.countData = data.data
            this.calculateCount(data.data)
            this.drawer = true
          }
        })
    },
    calculateCount (data) {
      for (var i = 0; i < data.length; i++) {
        this.callCount += data[i].count
      }
    },
    handleDrawerBeforeClose (done) {
      this.callCount = 0
      done()
    },
    handleCountChange (val) {
      this.callCount = 0
      this.$axios.get('/api/admin/call_client/count?start_time=' + this.count_time)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.countData = data.data
            this.calculateCount(data.data)
          }
        })
    },
    handleChangeLine () {
      this.$axios.post('/api/admin/callLogs/changeLine', {lineNum: '1'})
        .then((res) => {
          let { data } = res
          if (data.code === 200) {
            this.$message.success(data.msg)
            this.line = '1'
          }
        })
    }
  },
  mounted () {
    this.getRecords()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .callCount
    marginLeft()
    .mb-10
      margin-bottom: .2rem
    .mt-10
      margin-top: .2rem
    .text-c
      text-align: center
    .text-r
      text-align: right
    .m-tabs-content
      padding: 0 .2rem 0 .4rem
  .el-form-item
    margin-bottom: .1rem
  .el-range-editor.el-input__inner
    padding: 0 .2rem
  .m-cell
    padding: .12rem .2rem
  .m-cell-td
    padding: .12rem .28rem
</style>



// WEBPACK FOOTER //
// src/pages/call_count/CallCount.vue